import {
  Button,
  ControlGroup,
  FormGroup,
  InputGroup,
  NumericInput,
} from "@blueprintjs/core";
import _ from "lodash";
import { UserLanguage } from "../../../lang/lang";
import { FormItemBuilder } from "../Form";
// import { FormBuilderT } from "../Form";

export const valid_number_keys = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  ",",
  "Backspace",
  "Enter",
  "Tab",
  "-",
];

interface CustomerOrderPosition {
  id: number;
  quantity: number;
  price: number;
  text: string;
}

export const OrderPositionsBuilder: FormItemBuilder = (bundle) => {
  let payload: Array<CustomerOrderPosition> = [];

  if (bundle.field_current_value && _.isArray(bundle.field_current_value)) {
    payload = _.cloneDeep(bundle.field_current_value);
  }

  const update_property = (
    index: number,
    property: keyof CustomerOrderPosition,
    value: string | number
  ) => {
    console.log(`updating property payload[${index}].${property} => ${value}`);

    if (payload[index])
      bundle.update_value(_.set(payload, [index, property], value));
  };

  const update_quantity = (index: number, quantity: number) =>
    update_property(index, "quantity", quantity);

  const update_price = (index: number, price: number) =>
    update_property(index, "price", price);

  const update_text = (index: number, text: string) =>
    update_property(index, "text", text);

  const remove_row = (index: number) => {
    bundle.update_value(_.clone(payload).filter((__, i) => i !== index));
  };

  let sum = 0;

  const rows = [];
  _.forEach(payload, (item, index) => {
    sum += item.price * item.quantity;
    rows.push(
      <ControlGroup
        key={bundle.field_index + "_" + index}
        style={{ marginBottom: 10 }}
      >
        <NumericInput
          placeholder={UserLanguage().data.quantity_scale.quantity}
          onValueChange={(a) => update_quantity(index, a)}
          value={item.quantity}
          leftIcon="full-stacked-chart"
          allowNumericCharactersOnly={true}
          disabled={
            bundle.form_state.submitting || bundle.field_properties.readonly
          }
          style={{ width: 100 }}
        />
        <InputGroup
          fill
          disabled={
            bundle.form_state.submitting || bundle.field_properties.readonly
          }
          placeholder={bundle.field_properties.placeholder}
          value={item.text}
          onChange={(e) => update_text(index, e.currentTarget.value)}
        />
        <NumericInput
          placeholder={UserLanguage().data.quantity_scale.price}
          allowNumericCharactersOnly={false}
          buttonPosition="none"
          asyncControl
          style={{ width: 100 }}
          disabled={
            bundle.form_state.submitting || bundle.field_properties.readonly
          }
          onBlur={(e) => {
            try {
              const n = parseFloat(
                (e.target as HTMLInputElement).value.split(",").join(".")
              );
              update_price(index, n);
            } catch {}
          }}
          onKeyDown={(e) => {
            const value = (e.target as HTMLInputElement).value; // (e.target as HTMLInputElement).value;
            console.log("onKeyDown", e, _.get(e.target, "value"));

            if (e.key === "-" && _.indexOf(value, "-") !== -1)
              e.preventDefault();

            if (e.key === "-") {
              console.log("try parsing float");
              console.log(value);

              try {
                const n = parseFloat(
                  (e.target as HTMLInputElement).value.split(",").join(".")
                );
                if (isNaN(n)) e.preventDefault();
              } catch {
                console.log("failed!");
                e.preventDefault();
              }
            }

            if (
              (e.key === "." || e.key === ",") &&
              (_.indexOf(value, ".") !== -1 || _.indexOf(value, ",") !== -1)
            )
              e.preventDefault();

            if (_.indexOf(valid_number_keys, e.key) === -1) {
              e.preventDefault();
              return;
            }
            if (e.key === "Enter" || e.key === "Tab") {
              try {
                const n = parseFloat(
                  (e.target as HTMLInputElement).value.split(",").join(".")
                );
                update_price(index, n);
              } catch {}
            }
          }}
          value={item.price.toFixed(3)}
          leftIcon="euro"
        />
        <NumericInput
          disabled
          value={(item.price * item.quantity).toFixed(3)}
          style={{ width: 100 }}
          buttonPosition="none"
          leftIcon="euro"
        />
        <Button
          icon="cross"
          intent="danger"
          onClick={() => remove_row(index)}
        />
      </ControlGroup>
    );
  });

  rows.push(
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      key={`${bundle.field_index}_actions`}
    >
      <ControlGroup key={bundle.field_index + "_add"}>
        <Button
          onClick={() => {
            payload.push({ price: 0, quantity: 1, text: "", id: -1 });
            bundle.update_value(payload);
          }}
          icon="add"
          intent="primary"
        />
      </ControlGroup>
      <div style={{ fontWeight: 800, marginLeft: 15 }}>
        {UserLanguage().data.order_positions.sum}: {sum.toFixed(3)}€
      </div>
    </div>
  );

  return (
    <FormGroup key={bundle.field_index} style={{ marginBottom: 0 }}>
      {rows}
    </FormGroup>
  );
};
